module.exports = __webpack_public_path__ + "static/media/Floette_gaussian2.639c6042.png";